import { useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";
import AppearanceRow from "./AppearanceRow";
import { isClaimedAction } from "@/lib/billingConstants";
import { aidFor } from "@/lib/billingAidStatus";

export default function ClientGroup({ clientName, grantType, entries, actions, notes = {}, fees = {}, aid, aidSuggestions, onActionChange, onNoteChange, onFeeChange, onAidChange, onUseAidSuggestion }) {
  const [collapsed, setCollapsed] = useState(false);
  const claimedCount = entries.filter(e => isClaimedAction(actions[e.id])).length;

  return (
    <div className="bg-white rounded-xl border border-slate-200 overflow-hidden">
      <button
        onClick={() => setCollapsed(c => !c)}
        className="w-full text-left px-4 py-3 flex items-center gap-3 hover:bg-slate-50 transition-colors border-b border-slate-100"
      >
        <div className="flex-1 min-w-0 flex flex-wrap items-center gap-2">
          <span className="text-sm font-bold text-slate-900">{clientName}</span>
          {grantType && (
            <span className="rounded-full border border-violet-200 bg-violet-50 px-2 py-0.5 text-xs font-bold text-violet-800">
              {grantType}
            </span>
          )}
          <span className="text-xs text-slate-400">{entries.length} appearance{entries.length !== 1 ? "s" : ""}</span>
          {claimedCount > 0 && <span className="text-xs font-semibold text-emerald-600">· {claimedCount} claimed</span>}
        </div>
        {collapsed ? <ChevronDown className="w-4 h-4 text-slate-400 flex-shrink-0" /> : <ChevronUp className="w-4 h-4 text-slate-400 flex-shrink-0" />}
      </button>
      {!collapsed && (
        <div className="p-3 space-y-2">
          {entries.map(entry => (
            <AppearanceRow
              key={entry.id}
              entry={entry}
              action={actions[entry.id]}
              note={notes[entry.id] || ""}
              onActionChange={onActionChange}
              fee={fees[entry.id]}
              onNoteChange={onNoteChange}
              onFeeChange={onFeeChange}
              aid={aid ? aidFor(aid, entry.id) : undefined}
              aidSuggestion={aidSuggestions?.get(entry.id)}
              onAidChange={onAidChange}
              onUseAidSuggestion={onUseAidSuggestion}
            />
          ))}
        </div>
      )}
    </div>
  );
}
